import React, { useEffect, useState } from 'react'
import ChatHeader from '../ChatHeader/ChatHeader'
import './Chat.css'
import { AddCircle, CardGiftcard, EmojiEmotions, Gif } from '@material-ui/icons'
import Message from '../Message/Message'
import { useSelector } from 'react-redux'
import { selectChannelId, selectChannelName } from '../../features/appSlice'
import db from '../../firebase'
import { selectUser } from '../../features/userSlice'
import firebase from 'firebase';

function Chat() {

    const user = useSelector(selectUser);
    const [input, setInput] = useState('');
    const channelId = useSelector(selectChannelId);
    const channelName = useSelector(selectChannelName);
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        if(channelId) {
            db.collection('channels').doc(channelId).collection('messages').orderBy('timestamp', 'desc').onSnapshot(snapshot => (
                setMessages(snapshot.docs.map(doc => doc.data()))
            ))
        }
    }, [channelId])

    const sendMessage = e => {
        e.preventDefault();

        db.collection('channels').doc(channelId).collection('messages').add({
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            message: input,
            user: user
        });

        setInput('');
    }

    return (
        <div className="chat">
            <ChatHeader channelName={channelName} />

            <div className="chat__messages">
                {messages.map(message => (
                    <Message timestamp={message.timestamp} message={message.message} user={message.user} />
                ))}
            </div>

            <div className="chat__input">
                <AddCircle />
                <form>
                    <input value={input} disabled={!channelId} placeholder={`Messages #${channelName}`} onChange={e => setInput(e.target.value)} />
                    <button onClick={sendMessage} className="chat__inputButton" type="submit">Send Message</button>
                </form>
                <div className="chat__inputIcons">
                    <CardGiftcard fontSize="large" />
                    <Gif fontSize="large" />
                    <EmojiEmotions fontSize="large" />
                </div>
            </div>
        </div>
    )
}

export default Chat
